<template>
  <div class="p-grid box line-content">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BoxCard"
}
</script>

<style scoped>

.box {
  align-items: center;
  padding: 6px;
  min-height: 50px;
  min-width: 200px;
  border-radius: 10px;
  border-right: 10px solid #689F38;
}

</style>